import Button from '../general/Button'
import { connect } from 'react-redux'
import toJS from '../../containers/general/toJS'
import getData from '../../functions/getData'
import { AUTH_CAPS } from '../../constants/state'
import hasCap from '../../functions/hasCap'
import { FETCH_PROGRAM_CAP } from '../../constants/caps'
import getDisabledClass from '../../functions/getDisabledClass'

const mapStateToProps = state => ({
    caps: getData(state, AUTH_CAPS)
})

const FetchProgramButton = ({buttonTransId, hasUpdates= false, caps, onFetchProgram}) => {
    // const disable = !hasCap(caps, FETCH_PROGRAM_CAP) || hasUpdates

    const disableTemporarily = hasUpdates
    const disablePermanently = !hasCap(caps, FETCH_PROGRAM_CAP)
    const disable = disableTemporarily || disablePermanently

    return (
        <div className="fetch-program-button fetch-button">
            {/* <div className={"buttons-fetch" + (disable ? " disabled" : "")}> */}
            <div className={getDisabledClass("buttons-fetch", disableTemporarily, disablePermanently)}>   
                <Button
                    className="button-submit"
                    transId={buttonTransId}
                    onClick={disable ? () => {} : onFetchProgram}
                    disabled={disable}
                    hideText={false}
                    type="submit"
                />
            </div>
        </div>
    )
}

export default connect(mapStateToProps)(toJS(FetchProgramButton)) 